import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnSeeSalesCustomers } from '@utils/columns'
import { getToday } from '@utils/time'
import Layout from '@components/Layout'
import ViewSalesModal from '@components/Modal/ViewSalesModal'
import { useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { http } from '@services/http'
import { fetchSalesPerson } from '@utils/fetchData'
import { debouncedSet } from '@utils/debounce'
import OrderPaymentModal from '@components/Modal/orderPaymentModal'
import { useSelector } from 'react-redux'
import { Select, Button, Input, Tooltip } from 'antd'
import { downloadExcel } from '@utils/downloadPdf'
import moment from 'moment'
import ViewIcon from '@assets/icons/viewSvg'
import MoneyIcon from '@assets/icons/MoneySvg'

const SeeSalesCustomers = () => {
	const { t } = useTranslation()
	const location = useLocation()
	const { department, roleNames, getMe } = useSelector((state) => state.main)

	const queryParams = window.location.search.split('cardCode=')[1]
	const cardCode =
		window.location.search.split('cardCode=')[1] ||
		localStorage.getItem('cardCode')

	const isAdminOrCashier =
		roleNames.includes('admin') || roleNames.includes('Cashier')

	const fetchSeeSales = async ({ queryKey }) => {
		const [_, page, cardCode, startDate, endDate] = queryKey

		try {
			let url = ''

			url = `api/salesdata/client-sales-debt?cardCode=${cardCode}&startDate=${startDate}&endDate=${endDate}&pageSize=1000&skip=${page}`
			const { data } = await http.get(url)

			const formattedData = data

			const hasMore = formattedData.length === 10 ? true : false
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const [currentPage, setCurrentPage] = useState(0)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const formattedDate = getToday()
	const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false)

	const [docNum, setDocNum] = useState('')
	const [cardName, setCardName] = useState('')
	const [slpName, setSlpName] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(formattedDate)
	const [slpAdmin, setSlpAdmin] = useState('')
	const [loadingExcel, setLoadingExcel] = useState(false)

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['seeSales', currentPage, cardCode, startDate, endDate],
		queryFn: fetchSeeSales,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: slpData = [], isLoading: slpLoading } = useQuery({
		queryKey: ['salesPerson'],
		queryFn: fetchSalesPerson,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const fetchOneSale = async (docEntry, api) => {
		if (!docEntry) return
		try {
			let url = `${api}?docEntry=${docEntry}`
			const { data } = await http.get(url)
			setSelectedRowData(data.data[0])
			console.log(data.data[0])
		} catch (error) {
			console.log(error)
		}
	}

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleRowClick = (record) => {
		if (record?.docType === 'Sales Order') {
			fetchOneSale(record?.docEntry, 'api/sales/sotuv-buyurtmasi')
			setIsModalVisible(true)
			console.log('Sales Order')
		} else if (record?.docType === 'Delivery Note') {
			fetchOneSale(record?.docEntry, 'api/sales/ortib-yuborilgan')
			setIsModalVisible(true)
			console.log('Delivery Note')
		} else if (record?.docType === 'Invoice') {
			fetchOneSale(record?.docEntry, 'api/sales/tugallangan-sotuvlar')
			setIsModalVisible(true)
			console.log('Invoice')
		}
	}

	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setCardName)
	}
	const handleSlpNameChange = (val) => {
		debouncedSet(val, setSlpName)
	}
	const handlePaymentModal = (record) => {
		if (record?.docType === 'Заказ') {
			fetchOneSale(record?.docEntry, 'api/sales/sotuv-buyurtmasi')
		}

		setIsPaymentModalVisible(true)
	}

	const columns = [
		{
			title: t('numZakaz'),
			dataIndex: 'docNum',
			key: 'docNum',
			text: 'center',
		},

		{
			title: t('date'),
			dataIndex: 'docDate',
			key: 'docDate',
			text: 'center',
			render: (text, record) => {
				return `${moment(text).format('DD.MM.YYYY')}`
			},
		},

		{
			title: t('mijoz'),
			dataIndex: 'cardName',
			key: 'cardName',
			text: 'center',
		},
		{
			title: t('docType'),
			dataIndex: 'docType',
			key: 'docType',
			text: 'center',
		},

		{
			title: t('salesSum'),
			dataIndex: 'docTotal',
			key: 'docTotal',
			text: 'center',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return `${formattedText}`
			},
		},
		{
			title: t('paymentSum'),
			dataIndex: 'paymentTotal',
			key: 'paymentTotal',
			text: 'center',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return `${formattedText}`
			},
		},

		{
			title: t('saldo'),
			dataIndex: 'saldo',
			key: 'saldo',
			text: 'center',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return `${formattedText} `
			},
		},

		// {
		// 	title: '',
		// 	dataIndex: 'action',
		// 	key: 'action',
		// 	text: 'center',
		// 	render: (text, record) => (
		// 		<div className="flex items-center justify-center flex-col gap-2">
		// 			<Tooltip title={t('seeSales')}>
		// 				<button
		// 					onClick={() => onView(record)}
		// 					className="bg-[#2198c7] text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
		// 				>
		// 					<ViewIcon />
		// 				</button>
		// 			</Tooltip>
		// 			{isAdminOrCashier && record?.docType == 'Заказ' && (
		// 				<Tooltip title={t('payments')}>
		// 					<button
		// 						onClick={() => {
		// 							handlePaymentModal(record)
		// 						}}
		// 						className="bg-blue-600 text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
		// 					>
		// 						<MoneyIcon />
		// 					</button>
		// 				</Tooltip>
		// 			)}
		// 		</div>
		// 	),
		// },
	]

	const handleDownloadExcel = () => {
		downloadExcel({
			url: 'api/excelgenerators/export-bp-documents',
			params: {
				cardCode,
				docNum,
				startDate,
				endDate,
				slpCode: isAdminOrCashier ? slpAdmin : getMe?.salesPersonCode,
				pageSize: 1000,
				pageToken: 0,
			},
			fileName: 'Akt-sverka',
			onLoadingChange: setLoadingExcel,
		})
	}

	return (
		<Layout>
			<Header
				title={'act-sverka'}
				currentPage={currentPage + 1}
				// handlePreviousPage={handlePreviousPage}
				// handleNextPage={handleNextPage}
				// hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onStartDateChange={handleStartDate}
				onEndDateChange={handleEndDate}
				startDate={startDate}
				endDate={endDate}
				formattedDate={formattedDate}
				isShowExcelBtn
				handleDownloadExcel={handleDownloadExcel}
				loadingExcel={loadingExcel}
				// renderFilters={() => {
				// 	return isAdminOrCashier ? (
				// 		<div className="flex flex-col gap-3">
				// 			<p>{t('salesManager')}</p>
				// 			<Select
				// 				value={slpAdmin}
				// 				onChange={setSlpAdmin}
				// 				className="w-[150px] h-8"
				// 				options={[
				// 					{
				// 						value: '',
				// 						label: t('all'),
				// 					},
				// 					...slpData.map((item) => ({
				// 						value: item.slpCode,
				// 						label: item.slpName,
				// 					})),
				// 				]}
				// 			/>
				// 		</div>
				// 	) : null
				// }}
			/>
			<ViewSalesModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => setIsModalVisible(false)}
				ship={false}
				incoming={false}
			/>
			<OrderPaymentModal
				visible={isPaymentModalVisible}
				data={selectedRowData}
				onClose={() => setIsPaymentModalVisible(false)}
			/>
		</Layout>
	)
}

export default SeeSalesCustomers
